function checkDocumentStatusAndExecute(eventName: string, status: string, callback: () => void) {
  if (document.readyState === status) {
    callback();
  } else {
    window.addEventListener(eventName, callback, { once: true });
  }
}

const executeAfterDOMEvent = (event: string, callback: () => void) => {
  if (!__CLIENT__) {
    callback();
  }
  if (event === 'DOMContentLoaded') {
    checkDocumentStatusAndExecute('DOMContentLoaded', 'interactive', callback);
  }

  if (event === 'load') {
    checkDocumentStatusAndExecute('load', 'complete', callback);
  }
};

export default executeAfterDOMEvent;
